import CompetitorAnalysis from "@/components/Apps/CompetitorAnalysis";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/competitors",
)({
  component: Competitors,
  beforeLoad: () => ({
    title: "Competitors",
    headerTitle: "Competitor Analysis",
    headerDescription:
      "Track and analyze competitor content to inspire your campaigns",
  }),
});

export default function Competitors() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background p-6">
      <div className="mx-auto w-full max-w-5xl">
        <CompetitorAnalysis />
      </div>
    </div>
  );
}
